import styled from 'styled-components'
import { Form } from 'semantic-ui-react'

export const StyledPseudoInput = styled(Form.Input)`
  cursor: default;
  opacity: 1 !important;

  input {
    border: 0px;
  }
`
export const ResponsiveGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr; /* default: 1 column */

  .ui.segment:first-child {
    margin-top: 1rem !important;
  }

  .ui.segment:last-child {
    margin-bottom: 1rem !important;
  }

  @media (min-width: 768px) and (max-width: 1000px) {
    grid-template-columns: 1fr; /* 1 columns */
  }

   @media (min-width: 1000px) and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr; /* 2 columns */
  }

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr; /* 3 columns */
  }

  @media (min-width: 1800px) {
    grid-template-columns: 1fr 1fr 1fr 1fr; /* 4 columns */
  }
`;

export const MilkTestsWrapper = styled.div`
margin-bottom: 2em;

 .ui.header {
  font-size: 18px !important;
  margin-bottom: 0px !important;
 }

 .ui.divider {
  margin-top: 0px !important;
 }
`